<template>
  <el-button size="mini" :style="{color: 'green'}" @click="handleView">Edit</el-button>
</template>

<script>
export default {
  name: 'ColumnViewBaseinfoBtn',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    }
  },
  methods: {
    handleView () {
      const routeName = this.$route.name
      const routeData = this.$router.resolve({
        name: 'BaseInfoEdit',
        params: { routeName, id: this.rowId }
      })

      window.open(routeData.href, '_blank')
    }
  }
}
</script>
